<template>
    <div v-if="isVisible" class="guide-tour" @keyup.esc="skipTour" tabindex="0">
        <!-- Karanlık Arkaplan -->
        <div class="guide-overlay"></div>

        <!-- Fokus Alanı (Daha Geniş ve Yuvarlak) -->
        <div v-if="currentStep" class="guide-focus" :style="focusStyle"></div>

        <!-- Mesaj Kutusu (Merkezde) -->
        <div v-if="currentStep" class="guide-message">
            <div class="message-content">
                <p>{{ currentStep.message }}</p>
                <div class="guide-controls">
                    <SupsisButton @click="previousStep" :disabled="currentStepIndex === 0" ghost primary xlarge>
                        Geri
                        <span class="shortcut">[←]</span>
                    </SupsisButton>
                    <SupsisButton @click="skipTour" ghost primary xlarge>
                        Atla
                        <span class="shortcut">[ESC]</span>
                    </SupsisButton>
                    <SupsisButton @click="nextStep" :primary="isLastStep" primary ghost xlarge>
                        {{ isLastStep ? "Bitir" : "İleri" }}
                        <span class="shortcut">[→]</span>
                    </SupsisButton>
                </div>
            </div>
        </div>

        <!-- Spiral Ok (Mesaj Alanından Fokus Alanına) -->
        <div
            class="guide-arrow"
            v-if="arrowStyle.display"
            :style="{
                top: arrowStyle.top + 'px',
                left: arrowStyle.left + 'px',
                width: arrowStyle.width + 'px',
                height: arrowStyle.height + 'px',
            }"
        >
            <svg
                :width="arrowStyle.width"
                :height="arrowStyle.height"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                stroke="url(#arrowGradient)"
                stroke-width="3"
            >
                <!-- Gradient tanımı -->
                <defs>
                    <linearGradient id="arrowGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" style="stop-color: #ff6b6b" />
                        <stop offset="50%" style="stop-color: #4ecdc4" />
                        <stop offset="100%" style="stop-color: #45b7d1" />
                    </linearGradient>
                </defs>

                <!-- Spiral benzeri kavis -->
                <path :d="arrowPath" stroke-linecap="round" stroke-linejoin="round" />

                <!-- Ok ucu -->
                <polygon v-if="arrowHeadPoints" :points="arrowHeadPoints" fill="url(#arrowGradient)" stroke="none" />
            </svg>
        </div>
    </div>
</template>

<script>
import SupsisButton from "../../views/Pages/Settings/components/SupsisButton.vue";

export default {
    name: "GuideTour",
    components: {
        SupsisButton,
    },
    data() {
        return {
            isVisible: false,
            currentStepIndex: 0,
            completedTourKeys: [],
            steps: [
                {
                    id: "app-switcher-intro",
                    path: "/chat",
                    el: ".app-switcher-button",
                    message:
                        "Bu buton ile Chat, Chatbot, Tickets, Tasks, Forms gibi Supsis'teki tüm uygulamalar arasında kolayca geçiş yapabilirsiniz. İhtiyacınız olan uygulamaya tek tıkla ulaşabilirsiniz.",
                },
                {
                    id: "profile-button",
                    path: "/chat",
                    el: ".dropdown-control-item.profile",
                    message:
                        "Profil bilgileriniz, bildirim ayarlarınızı , durumunuzu buradan değiştirebilirsiniz. Ayrıca hesabınızı güvenli bir şekilde çıkış yapabilirsiniz.",
                },
                {
                    id: "settings-button",
                    path: "/chat",
                    el: ".dropdown-control-item.settings",
                    message:
                        "Tüm ayarları buraya taşıdık. Bildirim ayarlarınızda burada. Kullanıcıları yönetmek, departmanları düzenlemek ve diğer ayarları buradan yapabilirsiniz.",
                },
                {
                    id: "integrations-button",
                    path: "/chat",
                    el: ".dropdown-control-item.integrations",
                    message: "Tüm entegrasyonları buradan yönetebilirsiniz. Kanallarınızı buradan yönetebilirsiniz.",
                },
                {
                    id: "sidebar-menu",
                    path: "/chat",
                    el: ".sidebar-menu",
                    message:
                        "Herhangi bir uygulamaya geçiş yaptığınız zaman o uygulama ile alakalı menüye buradan erişebilirsiniz.",
                },
                {
                    id: "helper-menu",
                    path: "/chat",
                    el: "#popoverHelpMenu",
                    message:
                        "Bir hata oluştu veya bir sorunuz varsa buradan yardım alabilirsiniz. Canlı destek hattımıza buradan erişebilirsiniz.",
                },
                {
                    id: "search-bar",
                    path: "/chat",
                    el: "#search-bar",
                    message:
                        "Akıllı arama çubuğu ile sistemdeki herhangi bir şeyi arayabilirsiniz. Arayacağınız şey bir sayfa  veya bir ayar veya bir kişi , otomasyon , chatbot olabilir. CTRL+K ile hızlıca arama çubuğuna erişebilirsiniz. aramak istediğiniz  bölüme direk tab tuşu odaklanarak arama yapabilirsiniz.",
                },
                {
                    id: "chat-filter",
                    path: "/chat",
                    el: ".contact-filters-toolbar > .add-button",
                    message:
                        "Çalışma listenizi dilediğiniz seçebilirsiniz veya kişileri dilediğiniz seçeneklerle filtreleyebilirsiniz.",
                },
                {
                    id: "chat-filter",
                    path: "/chat",
                    el: ".filters > .add-button",
                    message:
                        "Çalışma listenizi dilediğiniz seçebilirsiniz veya kişileri dilediğiniz seçeneklerle filtreleyebilirsiniz.",
                },
                {
                    id: "chat-sort",
                    path: "/chat",
                    el: ".chat-btn.add-sort-button",
                    message:
                        "Chat'teki kişilerinizi sıralamak için bu butona tıklayabilirsiniz. Sıralama seçeneklerini buradan seçebilirsiniz.",
                },
                {
                    id: "chat-group",
                    path: "/chat",
                    el: ".chat-btn.add-group-button",
                    message:
                        "Chat'teki kişilerinizi dilediğiniz zaman gruplara ayırabilirsiniz. Etikete göre , departmana göre , sahibine göre  vb. seçeneklerle gruplara ayırabilirsiniz.",
                },
                {
                    id: "chat-contact-switch",
                    path: "/chat",
                    el: ".btn-contact-switch",
                    message:
                        "Canlı destek hattınızı canlı izleyebilirsiniz.Bu görünümünde tüm temsilcilerinizi kuş bakışıyla görebilirsiniz hatta konuşmaları toplu olarak görebilir ve cevaplayabilirsiniz. Kısayol olarak TAB tuşu ile hızlıca canlı destek izleme ekranına erişebilirsiniz.",
                },
                {
                    id: "chat-contact-switch",
                    path: "/chat",
                    el: ".btn-sidebar-navigation",
                    message:
                        "Buraya tıklayarak menüyü açıp sabitleyebilirsiniz. Menüyü açıp kapatmak için de aynı butona tekrar tıklayabilirsiniz.",
                },
                {
                    id: "chat-team-chat",
                    path: "/chat",
                    el: `[data-menukey="teamChat"]`,
                    message:
                        "Takım içi konuşmalarınızı buradan yapabilirsiniz. Çalışma arkadaşlarınıza DM gönderebilirsiniz. Departman içi gruplar ve özel gruplar oluşturabilirsiniz.",
                },
            ],
            focusStyle: {
                top: "0px",
                left: "0px",
                width: "0px",
                height: "0px",
            },
            arrowStyle: {
                display: false,
                top: 0,
                left: 0,
                width: 0,
                height: 0,
            },
            arrowPath: "",
            arrowHeadPoints: "",
        };
    },
    computed: {
        currentStep() {
            return this.steps[this.currentStepIndex];
        },
        isLastStep() {
            return this.currentStepIndex === this.steps.length - 1;
        },
    },
    methods: {
        checkVisibility() {
            if (!this.steps.length) {
                return false;
            }

            const savedTours = localStorage.getItem("completedTourKeys");
            this.completedTourKeys = savedTours ? JSON.parse(savedTours) : [];

            var currentPath = this.$route.path;
            var availableSteps = this.steps.filter((step) => {
                var isPathMatch = step.path === currentPath || step.path === "/";
                var isCompleted = this.completedTourKeys.includes(step.id);
                return isPathMatch && !isCompleted;
            });

            if (availableSteps.length) {
                this.isVisible = true;
                this.$nextTick(() => {
                    this.updateFocusElement();
                });
            }
        },
        updateFocusElement() {
            if (!this.currentStep) {
                return;
            }
            var element = document.querySelector(this.currentStep.el);
            if (!element) {
                return;
            }

            var rect = element.getBoundingClientRect();

            // Delik boyutu artırmak için ekstra padding
            var FOCUS_PADDING = 40;
            var diameter = Math.max(rect.width, rect.height) + FOCUS_PADDING * 2;

            // Yuvarlak fokus alanı
            this.focusStyle = {
                position: "fixed",
                top: rect.top + rect.height / 2 - diameter / 2 + "px",
                left: rect.left + rect.width / 2 - diameter / 2 + "px",
                width: diameter + "px",
                height: diameter + "px",
                boxShadow: "0 0 0 9999px rgba(0, 0, 0, 0.85)",
                borderRadius: "50%",
                pointerEvents: "none",
            };

            this.$nextTick(() => {
                this.updateArrow(rect);
            });
        },
        updateArrow(focusRect) {
            // Fokus alanının merkezi
            var focusCenterX = focusRect.left + focusRect.width / 2;
            var focusCenterY = focusRect.top + focusRect.height / 2;

            // Mesaj kutusunu bul
            if (!this.$el) return;
            var messageEl = this.$el?.querySelector?.(".guide-message");
            if (!messageEl) {
                this.arrowStyle.display = false;
                return;
            }
            var messageRect = messageEl.getBoundingClientRect();

            // Mesaj kutusunun 4 köşesini hesapla
            var corners = [
                { x: messageRect.left, y: messageRect.top },
                { x: messageRect.right, y: messageRect.top },
                { x: messageRect.left, y: messageRect.bottom },
                { x: messageRect.right, y: messageRect.bottom },
            ];

            // Fokus alanına en yakın köşeyi bulalım
            var closestCorner = corners[0];
            var minDist = this.getDistance(corners[0].x, corners[0].y, focusCenterX, focusCenterY);

            for (var i = 1; i < corners.length; i++) {
                var dist = this.getDistance(corners[i].x, corners[i].y, focusCenterX, focusCenterY);
                if (dist < minDist) {
                    minDist = dist;
                    closestCorner = corners[i];
                }
            }

            // Ok başlangıç noktası en yakın köşe
            var startX = closestCorner.x;
            var startY = closestCorner.y;

            // Ok bitiş noktası fokus alanı merkezi
            var endX = focusCenterX;
            var endY = focusCenterY;

            // SVG kutusunun konumu
            var boxLeft = Math.min(startX, endX);
            var boxTop = Math.min(startY, endY);
            var boxWidth = Math.abs(endX - startX);
            var boxHeight = Math.abs(endY - startY);

            this.arrowStyle.display = true;
            this.arrowStyle.top = boxTop;
            this.arrowStyle.left = boxLeft;
            this.arrowStyle.width = boxWidth;
            this.arrowStyle.height = boxHeight;

            // Lokal koordinatlar
            var localStartX = startX - boxLeft;
            var localStartY = startY - boxTop;
            var localEndX = endX - boxLeft;
            var localEndY = endY - boxTop;

            // Spiral benzeri bir kavis oluşturmak için basit bir kontrol noktası
            var midX = (localStartX + localEndX) / 2;
            var midY = (localStartY + localEndY) / 2;
            var curveOffset = 40;
            var controlX = midX + curveOffset;
            var controlY = midY - curveOffset;

            // Q bezier (spirale kavis vermek için)
            this.arrowPath =
                "M " +
                localStartX +
                " " +
                localStartY +
                " Q " +
                controlX +
                " " +
                controlY +
                " " +
                localEndX +
                " " +
                localEndY;

            // Ok ucu - boyutu artırıldı
            var arrowSize = 12; // 8'den 12'ye çıkarıldı
            var angle = Math.atan2(localEndY - localStartY, localEndX - localStartX);
            var arrowLeftX = localEndX - arrowSize * Math.cos(angle + 0.4); // Açı biraz daha genişletildi
            var arrowLeftY = localEndY - arrowSize * Math.sin(angle + 0.4);
            var arrowRightX = localEndX - arrowSize * Math.cos(angle - 0.4);
            var arrowRightY = localEndY - arrowSize * Math.sin(angle - 0.4);

            this.arrowHeadPoints =
                localEndX +
                "," +
                localEndY +
                " " +
                arrowLeftX +
                "," +
                arrowLeftY +
                " " +
                arrowRightX +
                "," +
                arrowRightY;
        },
        getDistance(x1, y1, x2, y2) {
            var dx = x2 - x1;
            var dy = y2 - y1;
            return Math.sqrt(dx * dx + dy * dy);
        },
        nextStep() {
            if (this.isLastStep) {
                this.completeTour();
            } else {
                this.currentStepIndex++;
                this.$nextTick(() => {
                    this.updateFocusElement();
                });
            }
        },
        previousStep() {
            if (this.currentStepIndex > 0) {
                this.currentStepIndex--;
                this.$nextTick(() => {
                    this.updateFocusElement();
                });
            }
        },
        skipTour() {
            this.completeTour();
        },
        completeTour() {
            this.steps.forEach((step) => {
                if (!this.completedTourKeys.includes(step.id)) {
                    this.completedTourKeys.push(step.id);
                }
            });

            localStorage.setItem("completedTourKeys", JSON.stringify(this.completedTourKeys));
            this.isVisible = false;
        },
        handleKeyPress(e) {
            if (e.key === "ArrowRight") {
                this.nextStep();
            } else if (e.key === "ArrowLeft") {
                this.previousStep();
            } else if (e.key === "Escape") {
                this.skipTour();
            }
        },
    },
    mounted() {
        // İsterseniz burada ek eventler tanımlayabilirsiniz
    },
    created() {
        var self = this;
        setTimeout(function () {
            self.checkVisibility();
            window.addEventListener("resize", self.updateFocusElement);
            self.updateFocusElement();
            setTimeout(function () {
                self.updateFocusElement();
            }, 100);
        }, 1000);
        window.addEventListener("keydown", this.handleKeyPress);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.updateFocusElement);
        window.removeEventListener("keydown", this.handleKeyPress);
    },
    watch: {
        $route() {
            this.checkVisibility();
        },
    },
};
</script>

<style lang="scss" scoped>
.guide-tour {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    pointer-events: none;
}

// Karanlık Arkaplan
.guide-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: transparent;
}

// Fokus Alanı
.guide-focus {
    position: absolute;
    transition: all 0.15s ease;
    pointer-events: none;
}

// Mesaj Kutusu (Orta Ekran)
.guide-message {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    pointer-events: auto; // Butonların tıklanabilmesi için
    background: transparent; // Kutu görünmesin
    color: #ffffff; // Yazılar beyaz
    max-width: 600px;

    .message-content {
        //font-family: cursive; // Kıvrımlı bir yazı stili
        font-size: 32px;
        padding: 16px 0;

        p {
            margin-bottom: 16px;
            line-height: 1.5;
        }

        .guide-controls {
            display: flex;
            justify-content: space-between;
            gap: 8px;

            button {
                flex: 1;
            }

            .supsis-button {
                border: 1px solid white;
                color: white;
            }

            .shortcut {
                font-size: 12px;
                opacity: 0.7;
                margin-left: 4px;
                color: white;
            }
        }
    }
}

// Spiral Ok
.guide-arrow {
    position: absolute;
    pointer-events: none;
    z-index: 2;

    svg {
        overflow: visible;
    }
}

// Klavye odağı için outline'ı gizle
.guide-tour:focus {
    outline: none;
}
</style>
